import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectionsRoutingModule } from './connections-routing.module';
import { MatDialogContent, MatDialogModule } from "@angular/material/dialog";

import {
  ConnectionsListComponent
} from "@fry/connections/components/connections-list/connections-list.component";
import {
  CreateOrUpdateConnectionsDialogComponent
} from "@fry/connections/components/connections-list/create-or-update-connections-dialog.component";
import { ReactiveFormsModule } from "@angular/forms";
import {
  MatCard,
  MatCardActions,
  MatCardContent,
  MatCardHeader,
  MatCardTitle
} from "@angular/material/card";
import { MatButton, MatIconButton } from "@angular/material/button";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { FryCommonModule } from "@fry/components/common";
import {
  RisrAssessExamComponent
} from "@fry/connections/components/booking/risr-assess-exam.component";
import { UnboxedModule } from "@fry/ui";
import { EasFormModule } from "@fry/components/common/easform/easform.module";
import { MatIcon } from "@angular/material/icon";
import { AlertComponent } from '@fry/ui-material/alert';
import { CopyButton } from '@fry/components/common/clipboard/copy-button.component';
import { RsrBadgeComponent } from '@fry/ui-material/badge/badge.component';

@NgModule({
  declarations: [
    ConnectionsListComponent,
    CreateOrUpdateConnectionsDialogComponent,
    RisrAssessExamComponent
  ],
  providers: [],
  exports: [
    RisrAssessExamComponent
  ],
    imports: [
        CommonModule,
        FryCommonModule,
        ConnectionsRoutingModule,
        MatDialogModule,
        ReactiveFormsModule,
        MatCardHeader,
        MatCardTitle,
        MatButton,
        MatCard,
        MatCardContent,
        MatMenu,
        MatMenuItem,
        MatMenuTrigger,
        MatCardActions,
        MatIconButton,
        UnboxedModule,
        EasFormModule,
        MatDialogContent,
        MatIcon,
        AlertComponent,
        CopyButton,
        RsrBadgeComponent
    ]
})
export class ConnectionsModule {}
